import { minValue, NumberInput, required } from "react-admin";

export const MoneyInput = ({ source, label, validate = [required(), minValue(0)], disabled, helperText }) => (
  <NumberInput
    source={source}
    label={label}
    format={v => (v !== undefined && v !== null && v !== "" ? Number(v).toFixed(2) : "")}
    parse={v => (v === "" ? null : parseFloat(parseFloat(v).toFixed(2)))}
    validate={validate}
    disabled={disabled}
    helperText={helperText}
    onWheel={e => e.target.blur()}
  />
);
